module.exports = __webpack_public_path__ + "9d3fc229831b0f814bec79a28992f507.svg";